module.exports = __webpack_public_path__ + "img/picosante.562d4af7.png";